import moment from 'moment-timezone';
import { TIME_ZONE } from 'config';

// Apply before any calendar or schedule render. A late setDefault lets the
// first paint format dates in the browser zone and shift the selected day.
moment.tz.setDefault(TIME_ZONE);

export const zonedMoment = (value) => moment.tz(value, TIME_ZONE);

// Noon avoids a midnight instant falling on the previous calendar day.
export const calendarDay = (year, monthIndex, day) =>
  moment.tz({ year, month: monthIndex, date: day, hour: 12 }, TIME_ZONE);

// month is 0-indexed, matching Date and moment.
export const zonedDateTime = ({
  year,
  month,
  day,
  hour = 0,
  minute = 0,
  second = 0,
}) =>
  moment
    .tz(
      {
        year,
        month,
        date: day,
        hour,
        minute,
        second,
        millisecond: 0,
      },
      TIME_ZONE
    )
    .toDate();

// month is 1-indexed, matching the calendar picker.
export const monthDateRange = (year, month) => {
  const start = moment.tz({ year, month: month - 1, date: 1 }, TIME_ZONE);
  return {
    startDate: start.format('YYYY-MM-DD'),
    endDate: start.clone().endOf('month').format('YYYY-MM-DD'),
  };
};

export const toScheduledIso = (value) => moment(value).toISOString();
